import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api-service/api.service';
import { UIRouter, Transition } from "@uirouter/angular";

@Component({
  selector: 'app-reissue',
  templateUrl: './reissue.component.html',
  styleUrls: ['./reissue.component.less']
})
export class ReissueComponent implements OnInit {

	private error:string

  constructor(private apiService : ApiService, private router: UIRouter, private transition: Transition) {

  	this.apiService.reissue(transition.params().token)
    .then(response => {
        this.router.stateService.go('app.search');
    })
    .catch(error => {
      console.log(error.message,'Error message in Reissue component constructor');
       this.error = error.message;
    })
      
  }

  ngOnInit() {

  }

  //Token.reissue = $resource(loginAPI+'/api/v1/token/:token/reissue');
  //Token.validate = $resource(loginAPI+'/api/v1/token/:token/validate');
  //Token.logout = $resource(loginAPI+'/api/v1/token/:token/delete');

}



// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/cycler/apollo-admin/src/src/app/reissue/reissue.component.ts